Alerts = require 'views/lib/alerts'
Auth = require 'db/auth'
ApiPromise = require 'network/api-promise'
ApiError = require 'network/api-error'
BoardObserverOptionComponent = require 'views/board-menu/board-observer-option-component'
MemberMultiSelectAutocompleteComponent = require 'views/member/member-multi-select-autocomplete-component'
BoardMenuInviteTeamComponent = require 'views/board-menu/board-menu-invite-team-component'
Confirm = require 'views/lib/confirm'
l = require 'lib/localize'
localizeServerError = require 'lib/localize-server-error'
Member = require 'models/member'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'
mixin = require 'lib/mixin'
ModelLoader = require 'db/model-loader'
View = require 'view'
React = require 'react'
ReactDOM = require 'react-dom'
template = require 'views/templates/board_member_add_multiple'
DisplayInvitationLinkView = require 'views/invitation-link/display-invitation-link-view'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
t = require('views/internal/recup-with-helpers')('board_member_add_multiple')
track = require 'debug/track'
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
$ = require 'jquery'
_ = require 'underscore'

module.exports = class BoardMemberAddMultipleView extends View
  mixin DisplayInvitationLinkView, @
  viewTitleKey: 'invite to board'
  displayType: 'board-member-add-multiple'
  initialInviteMessage: t.l 'im-working-on-this-project-in-trello-and-wanted-to-share-it-with-you'

  events:
    # invitation links
    'click .js-show-invitation-link': 'showInvitationLink'
    'click .js-invitation-link': 'clickInvitationLink'
    'click .js-deactivate-link': 'deactivateInvitationLink'
    'click .js-copy-invitation-link': 'copyInvitationLink'

  initialize: ->
    @onAutocompleteSubmit = @onAutocompleteSubmit.bind(@)
    @onAutocompleteSearch = @onAutocompleteSearch.bind(@)
    @onObserverChange = @onObserverChange.bind(@)
    @onInviteTeamClick = @onInviteTeamClick.bind(@)
    @onInvitationMessageChange = @onInvitationMessageChange.bind(@)
    @selectInvitationMessage = @selectInvitationMessage.bind(@)
    @invitationMessageValue ?= @initialInviteMessage
    @observerValue = 'normal'
    @selectedMemberOptions = []
    @onSelectMemberOption = @onSelectMemberOption.bind(@)
    @onRemoveMemberOption = @onRemoveMemberOption.bind(@)

    organization = @model.getOrganization()
    if organization?
      @listenTo organization.memberList, 'add remove reset',
        @frameDebounce @renderAutocomplete

    @listenTo @model.memberList, 'add remove reset',
      @frameDebounce @renderAutocomplete

    # in case the bc org admins decides to change the invite permissions
    # when you are looking at this view.
    if organization?
      @listenTo organization, 'change:prefs', @frameDebounce @render

  remove: ->
    ReactDOM.unmountComponentAtNode(@$('.js-autocomplete-root')[0])
    org = @model.getOrganization()
    context = if org then 'organizationid': org.id else ''
    trackUe(
      'invite to board'
      'close'
      'popover'
      ''
      ''
      'by closing the popover'
      context
    )
    super

  loadOrgData: ->
    organization = @model.getOrganization()
    if organization? and @model.editable()
      if organization.isPO() && organization.isBusinessClass()
        orgModel = ModelLoader.loadOrganizationMembersMinimalWithAvailableLicenseCount organization.id
      else
        orgModel = ModelLoader.loadOrganizationMembersMinimal organization.id

      orgModel.then =>
        @renderAutocomplete()
        return
      .done()
    return

  render: ->
    organization = @model.getOrganization()
    data = {
      showMultiboardGuestWarning: organization?.isFeatureEnabled('multiBoardGuests')
    }
    @$el.html(template(data))
    @renderAutocomplete()
    @

  onAutocompleteSubmit: ->
    usernames = []
    membersAddedCount = 0
    newBillableGuestsAddedCount = 0

    _.forEach(@selectedMemberOptions, (option) =>
      member = if option.id then @modelCache.get('Member', option.id)
      if member
        @addMember(member)
        if option.wouldBecomeBillableGuest
          newBillableGuestsAddedCount++
        else
          membersAddedCount++
      else
        optionName = if option.email then option.email else option.username
        usernames.push(optionName)
    )

    emailRegex = /^[^@]+@[a-z0-9-]+(\.[a-z0-9-]+)+$/i

    Promise
      .map(usernames, (username, i) =>
        @getMemberFromUsername(username)
          .catch (err) => { hasError: true }
      )
      .then (results) =>
        isErrors = _.some(results, ({ hasError }) => hasError)
        isBlockedInvites = _.some(results, ({ blockInvite }) => blockInvite)

        if isBlockedInvites or isErrors
          _.each(results, ({ blockInvite, hasError }, i) =>
            @selectedMemberOptions[i].blockInvite = blockInvite
            @selectedMemberOptions[i].hasError = hasError
          )

        else
          _.each(results, ({ member }, i) =>
            username = usernames[i]
            if member?
              if @model.id not in member.get('idBoards')
                @addMember(member)
            else if emailRegex.test(username)
              @sendEmailInvite(username)
          )
          PopOver.hide()
          track('Invitations', 'Send Invites', 'Number of invites sent', '', results.length)
          track('Invitations', 'Send Invites', 'Changed invite message', '', @invitationMessageValue != @initialInviteMessage)

          boardId = @model.attributes.id
          isImageBackground = @model.attributes.prefs.backgroundImage?
          numLists = @model.listList.length
          numCards = 0
          numAttachments = 0
          numChecklists = 0

          @model.listList.models.forEach((list) ->
            numCards += list.cardList.length
            list.cardList.models.forEach((card) ->
              numAttachments += card.attachmentList.length
              numChecklists += card.checklistList.length
            )
          )

          boardData = { boardId, numLists, numCards, numAttachments,
            numChecklists, isImageBackground, membersAddedCount,
            newBillableGuestsAddedCount }

          trackUe('Invitations', 'adds', 'members', '', 'to board', 'by using invite to board component', boardData)

  getMemberFromUsername: (username) ->
    org = @model.getOrganization()

    memberPromise = ApiPromise
      method: 'get'
      url: "/1/members/#{ username }"
      data: { fields: ['idOrganizations', 'idBoards'] }
    .then (data) =>
      new Member(data, modelCache: @modelCache)
    .catch ApiError.NotFound, (err) ->
      null

    # If the current user is not an admin, and they are attempting to invite a
    # single board guest (which would incur extra billing), this promise should resolve
    # to true.
    blockInvitePromise =
      if org && (!org.isFeatureEnabled('multiBoardGuests') || org.owned()) &&
        org.getAvailableLicenseCount() > 0
          false
      else
        ApiPromise
          url: '/1/search/members/'
          type: 'get'
          data:
            idBoard: @model.id
            idOrganization: org?.id
            onlyOrgMembers: org?.externalMembersDisabled()
            query: username
          dataType: 'json'
        .then (data) =>
          data.length == 1 and data[0].wouldBecomeBillableGuest

    Promise
      .all [memberPromise, blockInvitePromise]
      .then ([member, blockInvite]) => { member, blockInvite }

  addMember: (member) ->
    if maybeDisplayMemberLimitsError(@$el, @model, member)
      return
    @model.addMember member, @observerValue, @invitationMessageValue, (err, resp) ->
      if err
        errorMessage = localizeServerError(err.message)
        Alerts.showLiteralText(errorMessage, 'error', 'alert', 5000)

  sendEmailInvite: (email) ->
    data =
      email: email
      type: @observerValue
      invitationMessage: @invitationMessageValue

    if maybeDisplayMemberLimitsError(@$el, @model)
      return

    ApiPromise
      url: "/1/board/#{@model.id}/members"
      type: 'put'
      dataType: 'json'
      data: data
    .then (data) =>
      member = new Member(data, modelCache: @modelCache)
      track("Invitations", "Send Email Board Invite to New Member", "Role: #{data.type}")

  onAutocompleteSearch: (query) ->
    query = query.toLowerCase().trim()
    org = @model.getOrganization()
    if query.length > 2
      return ApiPromise(
        url: '/1/search/members/'
        type: 'get'
        data:
          idBoard: @model.id
          idOrganization: org?.id
          onlyOrgMembers: org?.externalMembersDisabled()
          query: query
        dataType: 'json'
      )
    else if org? && query.length > 0
      # The server isn't going to give us any results for searches that are
      # 2 characters or less … we can at least help by trying to see if there
      # are team members that would match
      return org.memberList.chain()
        .filter (member) ->
          _.any Util.getMemNameArray(member), (part) ->
            part.indexOf(query) == 0
        .map (member) =>
          _.extend member.toJSON(), {
            active: true,
            similarity: 0,
            joined: @model.getMembershipFor(member)?
            idOrganizations: [org.id]
          }
        .value()
    else if org?
      return org.memberList
        .map (member) =>
          _.extend member.toJSON(), {
            active: true,
            similarity: 0,
            joined: @model.getMembershipFor(member)?
            idOrganizations: [org.id]
          }
    else
      return []

  onInviteTeamClick: (e) ->
    track("Invitations", "Add All Org Members to Board")

    memsAvailable = @model.orgMembersAvailable().map (member) =>
      _.extend member.toJSON(), {
        active: true,
        similarity: 0,
        joined: @model.hasActiveMembership(member)
        idOrganizations: [@model.getOrganization().id]
      }

    @selectedMemberOptions = _.uniq(
      _.union(@selectedMemberOptions, memsAvailable),
      false,
      (item) => if item.username then item.username else item.email
    )
    @renderAutocomplete()

  onObserverChange: (newValue) ->
    @observerValue = newValue
    @renderAutocomplete()

  onInvitationMessageChange: (e) ->
    @invitationMessageValue = e.target.value
    @renderAutocomplete()

  selectInvitationMessage: ->
    if @invitationMessageValue == @initialInviteMessage
      $('.js-invitation-message').select()

  onSelectMemberOption: (member) ->
    @selectedMemberOptions = _.uniq(
      _.union(@selectedMemberOptions, _.flatten [member]),
      false,
      (item) => if item.username then item.username else item.email
    )
    @selectInvitationMessage()
    @renderAutocomplete()

  onRemoveMemberOption: (idx) ->
    @selectedMemberOptions = @selectedMemberOptions.filter((_, i) => i != idx)
    @renderAutocomplete()

  renderAutocomplete: ->
    autocompleteProps = {
      @onAutocompleteSearch,
      displayDetails: true,
      displayUsername: false,
      onSubmit: @onAutocompleteSubmit
      submitText: t.l 'send-invitation'
      emptySearchText: t.l 'looks-like-that-person-isnt-a-trello-member-yet'
      placeholder: t.l 'email-address-or-name'
      searchOnFocus: @model.getOrganization()?
      onSelectMemberOption: @onSelectMemberOption
      onRemoveMemberOption: @onRemoveMemberOption
      selectedOptions: @selectedMemberOptions
    }

    if org = @model.getOrganization()
      availableToInvite = @model.orgMembersAvailable()
      availableToInvite = _.filter(availableToInvite, (member) =>
        return member.get('username') not in _.pluck(@selectedMemberOptions, 'username')
      )
      if availableToInvite.length > 0
        autocompleteProps.extraSearchOption = React.createElement(
          BoardMenuInviteTeamComponent,
            onClick: @onInviteTeamClick
            org: org
            availableToInvite: availableToInvite
        )
      else
        autocompleteProps.searchOnFocus = false
      autocompleteProps.displayOrg = org

    children = []
    if @model.getOrganization()?.isPremium()
      children.push React.createElement(
        BoardObserverOptionComponent,
        {
          onChange: @onObserverChange
          value: @observerValue
          key: 'observerOption'
        }
      )

    children.push React.createElement(
      'textarea',
      {
        onChange: @onInvitationMessageChange,
        onClick: @selectInvitationMessage,
        className: 'invitation-message-input js-invitation-message',
        value: @invitationMessageValue,
        key: 'invitationMessage'
        placeholder: t.l 'sharing-is-caring-let-your-collaborators-know-what-youre-working-on'
      }
    )
    ReactDOM.render(
      React.createElement(
        MemberMultiSelectAutocompleteComponent,
        autocompleteProps,
        children
      ),
      @$('.js-autocomplete-root')[0]
    )



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-member-add-multiple-view.coffee